import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetAdminList = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const search = searchParams.get("search")

    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/list?page=${page}&search=${search || ""}`)
    }, [page, search])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "page") setAlert("페이지 번호를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "search") setAlert("검색어를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetAdminList